import React, { Component } from "react";
import MessagesList from "../components/MessagesList";
import axios from "axios";
import { API_HOST } from "../components/utils/api-config";
class MessagesContainer extends Component {
  constructor() {
    super();
    this.state = {
      messages: null,
    };
  }

  componentDidMount() {
    if (this.props.id) {
      axios
        .get(`${API_HOST}/messages/order_messages?id=${this.props.id}`)
        .then((response) =>
          this.setState({
            messages: response.data,
          })
        );
    } else {
      axios.get(`${API_HOST}/messages`).then((response) =>
        this.setState({
          messages: response.data,
        })
      );
    }
  }

  render() {
    return !this.state.messages ? (
      <h1>Loading</h1>
    ) : (
      <div className="container-fluid pt-5">
        <h1>Customer and Driver Messages </h1>
        <MessagesList messages={this.state.messages} />
      </div>
    );
  }
}

export default MessagesContainer;
